import CurrencyItem from "../type/currency-item";

export default {
  hidden: true,
  locked: false,
  price: CurrencyItem.create({
    kennziffer: "kennziffer",
    id: "price",
    name: "price",
    symbol: "€",
    iso: "eur",
    rate: 1,
    denomination: [1],
    minDenomination: 1
  }),
  current: { iso: "invalid", items: [] },

  open: function (item, onclose) {
    this.currentItem = item;
    this.price = CurrencyItem.create({
      kennziffer: item.kennziffer,
      id: "price",
      name: "price",
      symbol: "€",
      iso: item.iso,
      rate: item.rate,
      denomination: [item.minDenomination],
      minDenomination: item.minDenomination
    });
    if (item.selectedDenomination != null && item.selectedDenomination.items.length > 0) {
      this.current = item.cloneSelectedDenomination();
      this.calculate();
    } else {
      this.current = { iso: item.iso, items: [] };
      this.current.items = item.denomination.map(note => ({ note, amount: 0, count: 0, timeout: null }));
    }
    this.hidden = false;
    this.onclose = onclose;
  },

  close: function () {
    this.hidden = true;
    if (typeof this.onclose === "function") {
      this.onclose(this.currentItem.amountModel);
      this.onclose = null;
    }
  },

  calculate: function () {
    this.price.reset();
    this.current.items.forEach(item => {
      this.price.addAmount(item.amount);
    })
  },

  focusDenomination: function (item) {
    if (item.amount === 0 || item.amount === "0")
      item.amount = "";
  },

  blurDenomination: function (item) {
    if (item.amount === "")
      item.amount = 0;
  },

  changeDenomination: function (item) {
    this.validateItem(item);
    this.calculate();
  },

  validateItem: function (item) {
    item.amount = (isNaN(item.amount) && item.amount === "") ? 0 : parseInt(item.amount);
    item.count = Math.round(item.amount / item.note);
    item.amount = item.note * item.count;
  },

  accept: function () {
    // ensure all our amounts are valid
    let item, i;
    let dirty = false;
    for (i = 0; i < this.current.items.length; i++) {
      item = this.current.items[i];
      if (item.timeout != null) {
        window.clearTimeout(item.timeout);
        item.timeout = null;
        this.validateItem(item);
        dirty = true;
      } else {
        // just to be sure ...
        this.current.items[i].amount = (this.current.items[i].amount === "") ? 0 : parseInt(this.current.items[i].amount);
      }
    }
    if (dirty)
      this.calculate();
    if (this.price.getAmount() > 0) {
      this.currentItem
        .setSelectedDenomination(this.current)
        .setSelectedIso()
        .showEuro()
        .setAmount(this.price.getAmount());
    } else {
      this.currentItem.setSelectedDenomination(null);
    }
  }
};
